export default "__VITE_ASSET__0227f598__"